<template>
  <IOdometer
    id="js__total"
    :value="num"
    format="( ddd)"
    :duration="1000"
  />
</template>
 
<script type="text/babel">
  import IOdometer from 'vue-odometer';
  import 'odometer/themes/odometer-theme-default.css';
 
  export default {
    components: {
      IOdometer
    },
    data() {
      return {
        num: 0
      };
    }
  };
</script>
